import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
// import objectFitImages from 'object-fit-images';
// import objectFitVideos from 'object-fit-videos';
import Swiper from 'swiper';
import menu from "./components/menu";
import cursor from "./components/cursor";
import loader from "./components/loader";
import logo from "./components/logo";
import scrollReveal from "./helpers/scroll-reveal";
import projectsSlider from "./pages/about";
import servicePageLogo from "./pages/service-page";

export default () => {
  loader();
  menu();
  cursor();
  scrollReveal();
  projectsSlider();
  videoAutoplay();
  servicePageLogo();

  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  function videoAutoplay() {
    let videos = document.querySelectorAll('video');
    if(videos.length) {
      videos.forEach(function(video) {

        // forward direction
        ScrollTrigger.create({
          trigger: video,
          start: "top bottom",
          end: "bottom top",
          onEnter: () => {
            video.play();
          },

          onLeave : () => {
            video.pause();
          },
          onEnterBack: () => {
            video.play();
          },
          onLeaveBack : () => {
            video.pause();
          },
        });
      });
    }
  }

  // function getImageLightness(imageSrc,callback) {
  //     let img = document.createElement("img");
  //     img.src = imageSrc;
  //     img.style.display = "none";
  //     document.body.appendChild(img);

  //     let colorSum = 0;

  //     img.onload = function() {
  //         // create canvas
  //         let canvas = document.createElement("canvas");
  //         canvas.width = this.width;
  //         canvas.height = this.height;

  //         let ctx = canvas.getContext("2d");
  //         ctx.drawImage(this,0,0);

  //         let imageData = ctx.getImageData(0,0,canvas.width,canvas.height);
  //         let data = imageData.data;
  //         let r,g,b,avg;

  //         for(let x = 0, len = data.length; x < len; x+=4) {
  //             r = data[x];
  //             g = data[x+1];
  //             b = data[x+2];

  //             avg = Math.floor((r+g+b)/3);
  //             colorSum += avg;
  //         }

  //         let brightness = Math.floor(colorSum / (this.width*this.height));
  //         callback(brightness);
  //     }
  // }

  // let images = document.querySelectorAll('img');
  // images.forEach(function(img) {
  //   getImageLightness(img.src, function(brightness){
  //       if (brightness>=127) {
  //         img.classList.add('img-light')
  //       } else {
  //         img.classList.add('img-dark')
  //       }
  //   });
  // });
}